import React from "react";
import { BoltIcon } from "@heroicons/react/24/solid";

// Indigo + bolt pill rendered next to the Complete status pill on the VQQ Details
// banner and the My VQQs grid when a VQQ reached Complete via Autorelease (ticket 13876).
// Kept as a standalone sibling of StatusBadges so the status enum stays untouched.
const AutoreleasedBadge = ({ className = "" }) => (
  <span
    className={`inline-flex items-center gap-1 rounded-full bg-indigo-50 px-2 py-0.5 text-xs font-medium text-indigo-700 border border-indigo-200 ${className}`}
    title="This VQQ was Autoreleased from a previous submission"
  >
    <BoltIcon className="h-3.5 w-3.5" aria-hidden="true" />
    Autoreleased
  </span>
);

export default AutoreleasedBadge;
